export default "__VITE_ASSET__3cfb95bc__"